module.exports = __webpack_public_path__ + "index/img/icon_zheng.76185b4b.svg";